<template>
  <app-shell>
    <vnt-header>Add category</vnt-header>
    <category-form />
  </app-shell>
</template>

<script>
import AppShell from '@/components/AppShell.vue'
import CategoryForm from '@/components/categories/CategoryForm.vue'

export default {
  name: 'AddCategoryView',

  components: {
    AppShell,
    CategoryForm
  }
}
</script>
